import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Panel } from "@/components/admin/Panel";

const LABELS = [["home_views", "Homepage visits"], ["booking_page_views", "Booking page visits"], ["checkouts_started", "Checkouts started"], ["bookings_completed", "Bookings completed"]];

export const Stats = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  return (
    <Panel title="Booking stats" desc="Last 30 days. Anonymous counts only, no third-party trackers or cookies." testid="stats-panel">
      {!s ? <p className="text-sm text-muted-foreground">Loading…</p> : (
        <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-l border-border">
          {LABELS.map(([k, l]) => (
            <div key={k} className="p-6 border-r border-b border-border" data-testid={`stat-${k}`}>
              <p className="font-serif text-4xl">{s[k]}</p><p className="text-sm text-muted-foreground mt-1">{l}</p>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
};
